import { render, staticRenderFns } from "./VehicleDriver.vue?vue&type=template&id=2affd366&scoped=true"
import script from "./VehicleDriver.vue?vue&type=script&lang=js"
export * from "./VehicleDriver.vue?vue&type=script&lang=js"
import style0 from "./VehicleDriver.vue?vue&type=style&index=0&id=2affd366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affd366",
  null
  
)

export default component.exports